import { Injectable } from '@angular/core';
import { MenuController, ModalController } from '@ionic/angular';
import { AuthModalComponent } from '../../../features/auth/auth-modal/auth-modal.component';
import { IAuthModalResponse } from '@core/interfaces';

@Injectable({
  providedIn: 'root'
})
export class AuthModalService {
  modalSignIn!: HTMLIonModalElement;

  constructor(
    private modalCtrl: ModalController,
    private menuCtrl: MenuController,
  ) {}

  async openSignInModal(props: Record<string, unknown> = {}): Promise<IAuthModalResponse> {
    this.modalSignIn = await this.modalCtrl.create({
      component: AuthModalComponent,
      cssClass: 'modal-type-common-medium',
      componentProps: props,
      id: 'authModal'
    });

    await this.modalSignIn.present();
    const result = await this.modalSignIn.onDidDismiss();

    if (await this.menuCtrl.getOpen())
      this.menuCtrl.close();

    return result;
  }
}
